import React from "react";
import { Input, Row } from "reactstrap";
import { ColPrompt } from "./index";
import { ColValue, ErrorDiv } from "../ProductionModule/index";
import { useMachineSetupContextUpdater } from "./useMachineSetupContextUpdater";
import { useMachineSetupContextState } from "./useMachineSetupContextState";
// Used on the DP5, Duro, Saurer TC2, Xeno, and Xorella machines

export default function ProgramNameRow({ valueProp = "programName", titleProp = "Program Name", ColPromptSizeProp, ColValueSizeProp }) {
   const { onChange, onChangeErrorDivDefinitions } = useMachineSetupContextUpdater();
   const { machineSetup, errorDivDefinitions } = useMachineSetupContextState();
   return (
      <Row className="mb-2">
         <ColPrompt title={titleProp} bold={true} sizeProp={ColPromptSizeProp || 3} />
         <ColValue size={ColValueSizeProp || 4}>
            <Input
               type="text"
               style={{ borderRadius: "10px", fontSize: "14px" }}
               value={machineSetup.extendedPropertyJson?.[valueProp] || ""}
               onChange={(e) => {
                  if (e.target.value) {
                     onChange(valueProp, e.target.value, true);
                     if (errorDivDefinitions?.[valueProp]) {
                        onChangeErrorDivDefinitions(valueProp, false);
                     }
                  } else {
                     onChange(valueProp, "", true);
                     onChangeErrorDivDefinitions(valueProp, true);
                  }
               }}
            />
            {errorDivDefinitions?.[valueProp] &&
               <ErrorDiv>Cannot be left empty</ErrorDiv>}
         </ColValue>
      </Row>
   );
}
